import { RootState } from "../../../../store";
import { resourceExplorerFilterByKeyAndProviderSelector } from "../resourceExplorerFilterByKeyAndProviderSelector";
import {
  ResourceExplorerFilterItem,
  ProviderType,
} from "../../../../../services/cloudchipr.api";

export const dbSelectedInstanceTypeSelector = (
  state: RootState,
  provider: ProviderType,
): ResourceExplorerFilterItem => {
  const filter = resourceExplorerFilterByKeyAndProviderSelector(
    state,
    "instance_type",
    provider,
  );

  return {
    ...filter,
    cloud_provider: provider,
    operator: filter?.operator ?? "in",
    value: filter?.value ?? [],
    key: "instance_type",
  };
};
